// One app, two front doors. On a HortiHub host (hortihub.in, the Firebase
// preview, anything in REACT_APP_PORTAL_HOSTS) the root is the public landing
// page and sign-in offers the customer path only; on the CMS host the root
// is the staff login as always. The server does not care which host a
// request came from - roles decide what a token may do.

const DEFAULT_HOSTS = ["hortihub.in", "www.hortihub.in", "hortihub.web.app", "hortihub.firebaseapp.com"];

export function portalHosts() {
  const extra = (process.env.REACT_APP_PORTAL_HOSTS || "").split(",").map((h) => h.trim()).filter(Boolean);
  return [...DEFAULT_HOSTS, ...extra];
}

export function isPortalHost() {
  if (typeof window === "undefined") return false;
  const h = window.location.hostname.toLowerCase();
  if (window.location.search.includes("hortihub=1")) return true; // local preview of the landing page
  return portalHosts().some((p) => h === p || h.endsWith(`.${p}`));
}
